import { Action } from '@ngrx/store';
import { PerfilInicio } from 'src/app/models/SicarMap/perfilInicio.model';


export enum PerfilIniActionTypes {
  GET_PERFIL_INI = '[INICIO] GET_PERFIL',
  GET_PERFIL_INI_SUCCESS = '[INICIO] GET_PERFIL Success',
  GET_PERFIL_INI_FAILURE = '[INICIO] GET_PERFIL Failure'
}

export class GetPerfilIni implements Action {
  readonly type = PerfilIniActionTypes.GET_PERFIL_INI;
  constructor(public IdUsuario: number, public IdPerfil: number) {}
}
export class GetPerfilIniSuccess implements Action {
  readonly type = PerfilIniActionTypes.GET_PERFIL_INI_SUCCESS;
  constructor(public _perfilIni: PerfilInicio) {}
}

export class GetPerfilIniFailure implements Action {
  readonly type = PerfilIniActionTypes.GET_PERFIL_INI_FAILURE;
  constructor(public payload: any) {}
}

export type perfilIniAcciones =
  | GetPerfilIni
  | GetPerfilIniSuccess
  | GetPerfilIniFailure;